import { useQuery } from '@tanstack/react-query';
import { fetchLibraryMangedProductGroupProducts } from './apiFetchFeaturePageProducts';
import { GlobalReactQueryOptions } from '../../../../config';
import { browserClient } from '../../../../react-query';

export const LIBRARY_MANAGED_FEATURE_PAGE_PRODUCTS_QUERY = 'libraryManagedProductGroupProducts';

export const useFeaturePageProducts = ({
    featurePageId,
    productGroupIds
}: {
    featurePageId?: number;
    productGroupIds: number[];
}) => {
    const orderedProductGroupIds = productGroupIds.sort((a, b) => (a < b ? 1 : -1));

    return useQuery(
        [LIBRARY_MANAGED_FEATURE_PAGE_PRODUCTS_QUERY, orderedProductGroupIds.toString()],
        () => fetchLibraryMangedProductGroupProducts(productGroupIds),
        {
            ...GlobalReactQueryOptions,
            enabled: !!featurePageId && productGroupIds.length > 0
        }
    );
};

export function invalidateFeaturePageProducts() {
    return browserClient.invalidateQueries([LIBRARY_MANAGED_FEATURE_PAGE_PRODUCTS_QUERY]);
}
